// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"51e2864d","453":"a9ff7785"}[chunkId] + ".chunk.js";
};